import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export const getStartupEvents = ({ params = {} } = {}) => {
    return httpUtils.get(`${env.API_VERSION}/startup-events`, {
        params: {
            filter: params.filter,
            type: params.type,
            year: params.year,
            page: params.page,
            per_page: params.per_page,
        }
    });
};

export async function getStartupEventsByUser(config = {}) {
    return httpUtils.get(`${env.API_VERSION}/startup-events/by-user/list`, config);
}

export async function getStartupEventById(id, config) {
    return httpUtils.get(`${env.API_VERSION}/startup-events/${id}`, config);
}

export async function createStartupEvent(data, config) {
    return httpUtils.post(`${env.API_VERSION}/startup-events`, data, config);
}

export async function updateStartupEvent(id, data, config) {
    return httpUtils.put(`${env.API_VERSION}/startup-events/${id}`, data, config);
}

export async function deleteStartupEvent(id, config) {
    return httpUtils.delete(`${env.API_VERSION}/startup-events/${id}`, config);
}

export async function approveStartupEvent(id, data, config) {
    return httpUtils.post(`${env.API_VERSION}/startup-events/${id}/approve`, data, config);
}

export async function createStartupEventPayment(data, config) {
    return httpUtils.post(`${env.API_VERSION}/create-startup-event-payment`, data, config);
}

export async function publishStartupEvent(id, config) {
    return httpUtils.post(`${env.API_VERSION}/startup-events/${id}/publish`, config);
}

export async function unPublishStartupEvent(id, config) {
    return httpUtils.post(`${env.API_VERSION}/startup-events/${id}/unpublish`, config);
}